import { Config, DataGrid, EntityDialog, ErrorHandling, HtmlContentEditor, getjQuery } from "@serenity-is/corelib";
import { gridDefaults } from "@serenity-is/sleekgrid";
import { UserPreferenceStorage } from "@serenity-is/extensions";
import { siteLanguageList } from "./Helpers/LanguageList";
import { ExpiringSessionWarner } from '@/Common/Helpers/ExpiringSessionWarner/ExpiringSessionWarner';

Config.rootNamespaces.push('hsWartung');
EntityDialog.defaultLanguageList = siteLanguageList;
HtmlContentEditor.CKEditorBasePath = "~/Serenity.Assets/Scripts/ckeditor/";
gridDefaults.useCssVars = false;
gridDefaults.useLegacyUI = true;

let $ = getjQuery();
if ($?.fn?.colorbox) {
    $.fn.colorbox.settings.maxWidth = "95%";
    $.fn.colorbox.settings.maxHeight = "95%";
}

window.onerror = ErrorHandling.runtimeErrorHandler;
window.addEventListener('unhandledrejection', ErrorHandling.unhandledRejectionHandler);

DataGrid.defaultPersistanceStorage = new UserPreferenceStorage();

ExpiringSessionWarner.run();